import { useEffect } from "react";

import { enqueueSnackbar } from "notistack";

import { useAppDispatch, useAppSelector } from "app/hooks";

import { useSignalRHub } from "./hooks/useSignalRHub";
import { MessageHub } from "./hubs/MessageHub";
import { messagesThunks } from "./store/slice";
import { selectPendingInvokeCall } from "./selectors/selectors";

export function SignalROrchestrator() {
    const dispatch = useAppDispatch();

    // Connect to the main SignalR message hub
    const { isStarted, isError, invokeOnHub } = useSignalRHub(MessageHub);

    // Listen for queued calls to invoke on hub
    const pendingInvokeCall = useAppSelector(selectPendingInvokeCall);

    useEffect(() => {
        if (!isStarted) return;

        if (isError) {
            enqueueSnackbar(
                "iCOPP could not connect to SignalR message hub. You can continue working, but you will have a suboptimal experience.",
                {
                    variant: "warning",
                    autoHideDuration: 8000,
                },
            );

            return;
        }

        if (pendingInvokeCall) {
            invokeOnHub({
                methodName: pendingInvokeCall.methodName,
                methodArgs: pendingInvokeCall.payload,
            })
                .then(() => {
                    console.debug(
                        `Invoked signalr method ${pendingInvokeCall.methodName} on hub with payload: ${pendingInvokeCall.payload}`,
                    );
                })
                .catch((error) => {
                    console.error(
                        "Fatal error occurred trying to invoke hub method",
                        error,
                    );
                })
                .finally(() =>
                    dispatch(messagesThunks.completePendingInvokeCallAsync()),
                );
        }
    }, [pendingInvokeCall, isStarted, isError]);

    return undefined;
}
